import Cookies from 'js-cookie';

const SSOWeb = require('@mtfe/sso-web').default;
const isProduction = window.location.host === 'agent-repair-prompt.sankuai.com';

const VUE_APP_CLIENT_ID_PROD = '2c4ad23224';
const VUE_APP_CLIENT_ID_DEV = 'ab54c8213f';

export const ssoWeb = new SSOWeb({
    // 这里要写当前项目的 clientId  必填
    clientId: isProduction ? VUE_APP_CLIENT_ID_PROD : VUE_APP_CLIENT_ID_DEV,
    accessEnv: isProduction ? 'product' : 'test',
    callbackUrl: '/#/callback',  //登陆 SSO 后使用的回调路由，默认是 /sso/callback
});

export const sso = {
    clientId: isProduction ? VUE_APP_CLIENT_ID_PROD : VUE_APP_CLIENT_ID_DEV,
    redirectLogin() {
        ssoWeb.login()
    },
    redirectLoginNew() {
        window.location.href = ssoWeb.getLoginUrl();
    },
    logout() {
        ssoWeb.logout().then(() => {
            this.removeSsoid();
            this.setCurrentURL();
            this.redirectLoginNew();
        })
    },
    removeSsoid() {
        Cookies.remove('ssoid');
    },
    setSsoid(ssoid) {
        Cookies.set('ssoid', ssoid, {expires: 7});
    },
    getSsoid() {
        return Cookies.get('ssoid');
    },
    setCurrentURL() {
        const currentURL = window.location.href;
        if (!currentURL.includes('/callback')) {
            Cookies.set('currentURL', currentURL)
        }
    },
    getCurrentURL() {
        return Cookies.get('currentURL') || '/'
    }
};



// WEBPACK FOOTER //
// ./src/util/SSOUtil.js